import React, { Component } from 'react';

import 'assets/css/components/nav-toggle.css';

class NavToggle extends Component {
  render() {
    return (
      <button className={`nav-toggle phone-only ${this.props.navActive}`} onClick={this.props.onClick}>
        <span className="reader">Toggle Navigation</span>
        <i className="nav-toggle__icon">
        </i>
      </button>
    );
  }
}

export default NavToggle;



// WEBPACK FOOTER //
// ./src/Components/NavToggle.js